import { useAppStore } from '@store'
import { useEffect } from 'react'

export default function useUpdatedPrefs() {
  const resetTextures = useAppStore.use.resetTextures()
  const prefs = useAppStore.use.prefs()

  useEffect(() => {
    // Establece las constantes de colores con los valores de la store y los iconos/fondos
    const body = document.querySelector('body')
    body.style.setProperty('--color1', prefs?.['C/Color1'])
    body.style.setProperty('--color2', prefs?.['C/Color2'])
    body.style.setProperty('--color3', prefs?.['C/Color3'])
    body.style.setProperty('--color4', prefs?.['C/Color4'])
    body.style.setProperty('--color5', prefs?.['C/Color5'])
    body.style.setProperty('--color6', prefs?.['C/Color6'])
    body.style.setProperty('--color7', prefs?.['C/Color7'])
    body.style.setProperty('--color8', prefs?.['C/Color8'])
    body.style.setProperty('--color9', prefs?.['C/Color9'])
    body.style.setProperty('--color13', prefs?.['C/COLOR10'])
    body.style.setProperty('--color14', prefs?.['C/HoverMenu'])
    body.style.setProperty('--color15', prefs?.['C/FondoBuscarMenu'])
    body.style.setProperty('--color16', prefs?.['C/ContornoMenu'])
    body.style.setProperty('--color17', prefs?.['C/ContornoMenuSel'])
    body.style.setProperty('--color18', prefs?.['C/ContornoSubM'])
    body.style.setProperty('--color19', prefs?.['C/ContornoSubMSel'])
    body.style.setProperty('--color20', prefs?.['C/CirculoVertices'])
    body.style.setProperty('--urlBgIni', `url(${prefs?.FONDOCLIINICIAL})`)
    body.style.setProperty('--urlBgLog', `url(${prefs?.FONDOCLILOGIN})`)
    body.style.setProperty('--urlBgInfo', `url(${prefs?.FONDOCLITUTORIAL})`)
    body.style.setProperty('--color21', prefs?.['C/ColorC01'])
    body.style.setProperty('--color22', prefs?.['C/ColorC02'])
    body.style.setProperty('--color23', prefs?.['C/ColorC03'])
    body.style.setProperty('--color24', prefs?.['C/ColorC04'])
    body.style.setProperty('--color25', prefs?.['C/ColorC05'])
    body.style.setProperty('--color26', prefs?.['C/ColorC06'])
    body.style.setProperty('--color27', prefs?.['C/ColorC07'])
    body.style.setProperty('--color28', prefs?.['C/ColorC08'])
    body.style.setProperty('--color29', prefs?.['C/ColorC09'])
    body.style.setProperty('--color30', prefs?.['C/ColorC10'])
    body.style.setProperty('--color31', prefs?.['C/ColorC11'])
    body.style.setProperty('--color32', prefs?.['C/ColorD01'])
    body.style.setProperty('--color33', prefs?.['C/ColorD02'])
    body.style.setProperty('--color34', prefs?.['C/ColorD03'])
    body.style.setProperty('--color35', prefs?.['C/ColorD04'])
    body.style.setProperty('--color36', prefs?.['C/ColorD05'])
    body.style.setProperty('--color37', prefs?.['C/ColorD06'])
    body.style.setProperty('--color38', prefs?.['C/ColorD10'])
    body.style.setProperty('--color39', prefs?.['C/ColorC12'])
    body.style.setProperty('--color40', prefs?.['C/ColorF01'])
    body.style.setProperty('--color41', prefs?.['C/ColorF02'])
    body.style.setProperty('--color42', prefs?.['C/ColorF03'])
    body.style.setProperty('--color43', prefs?.['C/ColorF04'])
    body.style.setProperty('--color44', prefs?.['C/ColorF05'])
    body.style.setProperty('--color45', prefs?.['C/ColorF06'])
    body.style.setProperty('--color46', prefs?.['C/ColorF10'])
    body.style.setProperty('--color47', prefs?.['C/ColorF11'])
    body.style.setProperty('--color48', prefs?.['C/ColorE07'])
    body.style.setProperty('--color49', prefs?.['COLORTEXTOBISAGRA'])
    resetTextures(
      prefs?.CATALOGOUNIVERSAL,
      prefs?.UNIDADSUELO,
      prefs?.UNIDADPARED0,
      prefs?.UNIDADPARED1,
      prefs?.UNIDADTECHO,
      prefs?.UNIDADTABIQUE0,
      prefs?.UNIDADTABIQUE1,
      prefs?.UNIDADTABIQUE2,
      prefs?.UNIDADTABIQUE3,
      prefs?.UNIDADTABIQUE4,
      prefs?.UNIDADTABIQUE5,
    )
  }, [
    prefs?.['C/Color1'],
    prefs?.['C/Color2'],
    prefs?.['C/Color3'],
    prefs?.['C/Color4'],
    prefs?.['C/Color5'],
    prefs?.['C/Color6'],
    prefs?.['C/Color7'],
    prefs?.['C/Color8'],
    prefs?.['C/Color9'],
    prefs?.['C/COLOR10'],
    prefs?.UNIDADPARED0,
    prefs?.UNIDADTECHO,
    prefs?.UNIDADPARED1,
    prefs?.UNIDADSUELO,
    prefs?.CATALOGOUNIVERSAL,
    prefs?.['C/CirculoVertices'],
    prefs?.['C/ContornoSubMSel'],
    prefs?.['C/ContornoSubM'],
    prefs?.['C/ContornoMenuSel'],
    prefs?.['C/ContornoMenu'],
    prefs?.['C/FondoBuscarMenu'],
    prefs?.['C/HoverMenu'],
    prefs?.FONDOCLIINICIAL,
    prefs?.FONDOCLILOGIN,
    prefs?.['C/ColorC01'],
    prefs?.['C/ColorC02'],
    prefs?.['C/ColorC03'],
    prefs?.['C/ColorC04'],
    prefs?.['C/ColorC05'],
    prefs?.['C/ColorC06'],
    prefs?.['C/ColorC07'],
    prefs?.['C/ColorC08'],
    prefs?.['C/ColorC09'],
    prefs?.['C/ColorC10'],
    prefs?.['C/ColorC11'],
    prefs?.['C/ColorD01'],
    prefs?.['C/ColorD02'],
    prefs?.['C/ColorD03'],
    prefs?.['C/ColorD04'],
    prefs?.['C/ColorD05'],
    prefs?.['C/ColorD06'],
    prefs?.['C/ColorD10'],
    prefs?.['C/ColorC12'],
    prefs?.['C/ColorF01'],
    prefs?.['C/ColorF02'],
    prefs?.['C/ColorF03'],
    prefs?.['C/ColorF04'],
    prefs?.['C/ColorF05'],
    prefs?.['C/ColorF06'],
    prefs?.['C/ColorF10'],
    prefs?.['C/ColorF11'],
    prefs?.['C/ColorE07'],
  ])
}
